module.exports = __webpack_public_path__ + "img/shin_icon.00f60b2b.jpg";